// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#maneuver-sat-info:not(.collapsed) {
  transition: max-height 0.5s ease-in-out;
  max-height: 2000px;
  overflow: hidden;
  margin: 5px 0px;
}`, "",{"version":3,"sources":["webpack://./src/plugins/sat-info-box-orbit-guard/sat-info-box-orbit-guard.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["#maneuver-sat-info:not(.collapsed) {\n  transition: max-height 0.5s ease-in-out;\n  max-height: 2000px;\n  overflow: hidden;\n  margin: 5px 0px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
